import { render, staticRenderFns } from "./liaisonPreview.vue?vue&type=template&id=e21dfc8a&scoped=true&"
import script from "./liaisonPreview.vue?vue&type=script&lang=tsx&"
export * from "./liaisonPreview.vue?vue&type=script&lang=tsx&"
import style0 from "./liaisonPreview.vue?vue&type=style&index=0&id=e21dfc8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21dfc8a",
  null
  
)

export default component.exports